import type { DealType } from "~/models/Deal";

export type PastDealSummary = {
	companyVendorName: string | null;
	completionReportImageCount: number;
	constructionEndDate: string | null;
	dealId: number;
	dealType: DealType;
	estimationTotalAmount: number | null;
	estimationTotalAmountWithTax: number | null;
	inspectionReportImageCount: number;
	ownerBillingTotalAmount: number | null;
	ownerBillingTotalAmountWithTax: number | null;
	renteeBillingTotalAmount: number | null;
	renteeBillingTotalAmountWithTax: number | null;
	subtypeName: string | null;
};

export type PastDealGroup = {
	deals: PastDealSummary[];
	name: string;
	propertyDealId: number;
	roomNumber: string | null;
	totals: {
		estimationAmount: number | null;
		ownerBillingAmount: number | null;
		renteeBillingAmount: number | null;
	};
};

export type PastDealListSection = {
	count: number;
	objects: PastDealGroup[];
};

export type PastDealList = {
	building: PastDealListSection;
	itemsPerPage: number;
	room: PastDealListSection;
};

export const hasAnyPastDeals = (pastDeals: PastDealList | null): boolean =>
	(pastDeals?.room.count ?? 0) > 0 || (pastDeals?.building.count ?? 0) > 0;

export const hasSameDealTypePastDeals = (
	pastDeals: PastDealList | null,
	dealType: DealType
): boolean =>
	(pastDeals?.building.objects ?? []).some((group) =>
		group.deals.some((pastDeal) => pastDeal.dealType === dealType)
	);
